import { render } from "./ClassifiedStatistics.vue?vue&type=template&id=72f6129a&scoped=true"
import script from "./ClassifiedStatistics.vue?vue&type=script&lang=js"
export * from "./ClassifiedStatistics.vue?vue&type=script&lang=js"

import "./ClassifiedStatistics.vue?vue&type=style&index=0&id=72f6129a&scoped=true&lang=css"

import exportComponent from "D:\\code\\h5\\vue-lib\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72f6129a"]])

export default __exports__